import React from 'react';
import { List, Button } from 'devextreme-react';
import { formatDistance } from 'date-fns';
import { de } from 'date-fns/locale';
import { usePushNotificationContext } from '../../contexts/pushNotifications';
import './NotificationList.scss';

const NotificationList = () => {
  const {
    notifications,
    unreadCount,
    markNotificationAsRead,
    clearAllNotifications
  } = usePushNotificationContext();

  const renderNotificationItem = (data) => {
    const notification = data;
    const isUnread = !notification.read;
    
    const handleNotificationClick = () => {
      if (isUnread) {
        markNotificationAsRead(notification.id);
      }
      
      // Hier können Sie zur entsprechenden Seite navigieren
      // basierend auf notification.data
      console.log('Navigiere zu:', notification.data);
    };

    return (
      <div 
        className={`notification-item ${isUnread ? 'unread' : ''}`}
        onClick={handleNotificationClick}
      >
        <div className="notification-content">
          <div className="notification-title">
            {notification.title || 'Benachrichtigung'}
          </div>
          <div className="notification-body">
            {notification.body || 'Keine Details verfügbar'}
          </div>
          {notification.data && (
            <div className="notification-data">
              {Object.entries(notification.data).map(([key, value]) => (
                <span key={key} className="notification-tag">
                  {key}: {value}
                </span>
              ))}
            </div>
          )}
          <div className="notification-time">
            {notification.date ? 
              formatDistance(new Date(notification.date), new Date(), { 
                addSuffix: true, 
                locale: de 
              }) : 
              'Gerade eben'
            }
          </div>
        </div>
        {isUnread && <div className="unread-indicator"></div>}
      </div>
    );
  };

  return (
    <div className="notification-list-container">
      <div className="notification-header">
        <h3>
          Benachrichtigungen 
          {unreadCount > 0 && (
            <span className="unread-badge">{unreadCount}</span>
          )}
        </h3>
        {notifications.length > 0 && (
          <Button
            text="Alle löschen"
            type="normal"
            stylingMode="text"
            onClick={clearAllNotifications}
          />
        )}
      </div>
      
      {notifications.length === 0 ? (
        <div className="no-notifications">
          <p>Keine Benachrichtigungen vorhanden</p>
        </div>
      ) : (
        <List
          dataSource={notifications}
          itemRender={renderNotificationItem}
          searchEnabled={false}
          className="notification-list"
        />
      )}
    </div>
  );
};

export default NotificationList;
